export const environment = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
};
